export default {
  "pages.layouts.userLayout.title":
    "Hệ thống quản lý mã vạch chuyên nghiệp cho nền tảng Eatsy",
  "pages.login.accountLogin.tab": "Đăng nhập bằng tài khoản",
  "pages.login.accountLogin.errorMessage":
    "Sai tên đăng nhập/mật khẩu (admin/ant.design)",
  "pages.login.failure": "Đăng nhập thất bại, vui lòng thử lại!",
  "pages.login.success": "Đăng nhập thành công!",
  "pages.login.username.placeholder": "Tên đăng nhập: admin hoặc user",
  "pages.login.username.required": "Vui lòng nhập tên đăng nhập!",
  "pages.login.email.placeholder": "Địa chỉ email",
  "pages.login.email.required": "Vui lòng nhập địa chỉ email!",
  "pages.login.email.invalid": "Vui lòng nhập địa chỉ email hợp lệ!",
  "pages.login.password.placeholder": "Mật khẩu: ant.design",
  "pages.login.password.required": "Vui lòng nhập mật khẩu!",
  "pages.login.phoneLogin.tab": "Đăng nhập bằng điện thoại",
  "pages.login.phoneLogin.errorMessage": "Lỗi mã xác thực",
  "pages.login.phoneNumber.placeholder": "Số điện thoại",
  "pages.login.phoneNumber.required": "Vui lòng nhập số điện thoại!",
  "pages.login.phoneNumber.invalid": "Số điện thoại không hợp lệ!",
  "pages.login.captcha.placeholder": "Mã xác thực",
  "pages.login.captcha.required": "Vui lòng nhập mã xác thực!",
  "pages.login.phoneLogin.getVerificationCode": "Lấy mã",
  "pages.getCaptchaSecondText": "giây",
  "pages.login.rememberMe": "Ghi nhớ đăng nhập",
  "pages.login.forgotPassword": "Quên mật khẩu?",
  "pages.login.submit": "Đăng nhập",
  "pages.login.loginWith": "Đăng nhập bằng:",
  "pages.login.registerAccount": "Đăng ký tài khoản",
  "pages.welcome.link": "Chào mừng",
  "pages.welcome.alertMessage":
    "Các component nặng nhanh hơn và mạnh mẽ hơn đã được phát hành.",
  "pages.404.subTitle": "Xin lỗi, trang bạn truy cập không tồn tại.",
  "pages.404.buttonText": "Về trang chủ",
  "pages.admin.subPage.title": "Trang này chỉ có thể được xem bởi Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui hiện đã được phát hành, chào mừng sử dụng npm run ui để bắt đầu trải nghiệm.",
  "pages.searchTable.createForm.newRule": "Quy tắc mới",
  "pages.searchTable.updateForm.ruleConfig": "Cấu hình quy tắc",
  "pages.searchTable.updateForm.basicConfig": "Thông tin cơ bản",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Tên quy tắc",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Vui lòng nhập tên quy tắc!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Mô tả quy tắc",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Vui lòng nhập ít nhất năm ký tự",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Vui lòng nhập mô tả quy tắc ít nhất năm ký tự!",
  "pages.searchTable.updateForm.ruleProps.title": "Cấu hình thuộc tính",
  "pages.searchTable.updateForm.object": "Đối tượng giám sát",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Mẫu quy tắc",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Loại quy tắc",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Thiết lập chu kỳ lập lịch",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel":
    "Thời gian bắt đầu",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Vui lòng chọn thời gian bắt đầu!",
  "pages.searchTable.titleDesc": "Mô tả",
  "pages.searchTable.ruleName": "Tên quy tắc là bắt buộc",
  "pages.searchTable.titleCallNo": "Số lần gọi dịch vụ",
  "pages.searchTable.titleStatus": "Trạng thái",
  "pages.searchTable.nameStatus.default": "mặc định",
  "pages.searchTable.nameStatus.running": "đang chạy",
  "pages.searchTable.nameStatus.online": "trực tuyến",
  "pages.searchTable.nameStatus.abnormal": "bất thường",
  "pages.searchTable.titleUpdatedAt": "Lần lập lịch cuối",
  "pages.searchTable.exception": "Vui lòng nhập lý do ngoại lệ!",
  "pages.searchTable.titleOption": "Tùy chọn",
  "pages.searchTable.config": "Cấu hình",
  "pages.searchTable.subscribeAlert": "Đăng ký cảnh báo",
  "pages.searchTable.title": "Biểu mẫu truy vấn",
  "pages.searchTable.new": "Mới",
  "pages.searchTable.chosen": "đã chọn",
  "pages.searchTable.item": "mục",
  "pages.searchTable.totalServiceCalls": "Tổng số lần gọi dịch vụ",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "xóa hàng loạt",
  "pages.searchTable.batchApproval": "phê duyệt hàng loạt",
  // Conversations
  "pages.conversations.list.title": "Danh sách hội thoại AI",
  "pages.conversations.list.search.placeholder": "Tìm kiếm hội thoại...",
  "pages.conversations.detail.title": "Chi tiết hội thoại",
  "pages.conversations.status.active": "Hoạt động",
  "pages.conversations.status.archived": "Đã lưu trữ",
  "pages.conversations.status.deleted": "Đã xóa",
  "pages.conversations.tone.caring": "Quan tâm",
  "pages.conversations.tone.cheeky": "Vui vẻ",
  "pages.conversations.tone.clinical": "Chuyên nghiệp",
  "pages.conversations.tone.concise": "Ngắn gọn",
  "pages.conversations.tone.motivational": "Động viên",
  "pages.conversations.column.id": "ID",
  "pages.conversations.column.user": "Người dùng",
  "pages.conversations.column.title": "Tiêu đề",
  "pages.conversations.column.status": "Trạng thái",
  "pages.conversations.column.tone": "Giọng điệu",
  "pages.conversations.column.lastMessage": "Tin nhắn cuối",
  "pages.conversations.column.createdAt": "Ngày tạo",
  "pages.conversations.column.actions": "Thao tác",
  "pages.conversations.filter.status": "Lọc theo trạng thái",
  "pages.conversations.filter.userId": "Lọc theo User ID",
  "pages.conversations.filter.all": "Tất cả",
  "pages.conversations.viewDetail": "Xem chi tiết",
  "pages.shop-settings.title": "Cài đặt Shop",
  "pages.shop-settings.subtitle": "Cấu hình tính năng checkout trên app mobile",
  "pages.shop-settings.vat_invoice_enabled": "Thông tin xuất hóa đơn GTGT",
  "pages.shop-settings.vat_invoice_enabled_desc":
    "Bật để khách hàng có thể yêu cầu xuất hóa đơn GTGT khi thanh toán.",
  "pages.shop-settings.load_failed": "Không tải được cài đặt shop",
  "pages.shop-settings.save_success": "Đã cập nhật cài đặt shop",
  "pages.shop-settings.save_failed": "Không cập nhật được cài đặt shop",
  "pages.shop-settings.vn_admin_title": "Dữ liệu tỉnh / thành / phường xã",
  "pages.shop-settings.vn_admin_desc":
    "Đồng bộ lại 34 tỉnh/thành và phường/xã từ provinces.open-api.vn (API v2). Dùng khi cập nhật hành chính hoặc app không hiển thị phường/xã.",
  "pages.shop-settings.vn_admin_sync_button": "Đồng bộ dữ liệu tỉnh / phường xã",
  "pages.shop-settings.vn_admin_sync_confirm":
    "Thay thế toàn bộ dữ liệu tỉnh/thành và phường/xã trong hệ thống bằng dữ liệu mới nhất từ provinces.open-api.vn?",
  "pages.shop-settings.vn_admin_sync_confirm_ok": "Đồng bộ",
  "pages.shop-settings.vn_admin_sync_confirm_cancel": "Hủy",
  "pages.shop-settings.vn_admin_sync_success":
    "Đã đồng bộ {provinces} tỉnh/thành và {wards} phường/xã",
  "pages.shop-settings.vn_admin_sync_failed": "Không đồng bộ được dữ liệu tỉnh / phường xã",
  "pages.system-config.title": "Cấu hình hệ thống",
  "pages.system-config.subtitle": "Bảo trì mobile app và reindex tìm kiếm thực phẩm",
  "pages.system-config.maintenance_title": "Chế độ bảo trì (Mobile)",
  "pages.system-config.maintenance_mode": "Bật bảo trì",
  "pages.system-config.maintenance_mode_desc":
    "Khi bật, app mobile hiển thị màn hình bảo trì và chặn người dùng.",
  "pages.system-config.message_code": "Mã thông báo bảo trì",
  "pages.system-config.message_code_desc":
    "Mobile app hiển thị nội dung theo mã này qua file i18n (en/vi).",
  "pages.system-config.message_code.default": "Bảo trì mặc định",
  "pages.system-config.message_code.upgrade": "Nâng cấp hệ thống",
  "pages.system-config.message_code.scheduled": "Bảo trì theo lịch",
  "pages.system-config.estimated_end": "Dự kiến hoàn thành",
  "pages.system-config.save_button": "Lưu cấu hình",
  "pages.system-config.on": "Bật",
  "pages.system-config.off": "Tắt",
  "pages.system-config.load_failed": "Không tải được cấu hình hệ thống",
  "pages.system-config.save_success": "Đã cập nhật cấu hình hệ thống",
  "pages.system-config.save_failed": "Không cập nhật được cấu hình hệ thống",
  "pages.system-config.es_title": "Elasticsearch — Tìm kiếm thực phẩm",
  "pages.system-config.es_desc":
    "Reindex toàn bộ foods từ food_translations (display_name). Thao tác này có thể mất vài phút.",
  "pages.system-config.reindex_button": "Reindex Elasticsearch",
  "pages.system-config.reindex_confirm":
    "Xóa và tạo lại index foods, sau đó index lại toàn bộ thực phẩm?",
  "pages.system-config.reindex_confirm_ok": "Reindex",
  "pages.system-config.reindex_confirm_cancel": "Hủy",
  "pages.system-config.reindex_failed": "Reindex Elasticsearch thất bại",
};
